import { Add as AddIcon } from '@mui/icons-material';
import { CommonButton } from './CommonButton';

interface AddEventButtonProps {
  title: string;
  onAddClick: () => void;
}

export const AddEventButton = ({ title, onAddClick }: AddEventButtonProps) => {
  return (
    <CommonButton
      startIcon={<AddIcon />}
      onClick={onAddClick}
    >
      {title}
    </CommonButton>
  );
}; 